// src/features/checkout/paymentService.js

/**
 * Simulates a payment process.
 * Replace this with real payment provider integration (Stripe, PayPal, etc.)
 * @param {Object} paymentData
 * @param {string} paymentData.orderId - The order being paid
 * @param {number} paymentData.amount - Amount to charge
 * @param {string} paymentData.method - Payment method (e.g., "card", "paypal")
 * @param {Object} paymentData.details - Method-specific details (card number, etc.)
 * @returns {Promise<Object>} - Simulated payment response
 */
export const paymentService = async ({ orderId, amount, method, details }) => {
  return new Promise((resolve, reject) => {
    // Simulate network delay
    setTimeout(() => {
      // Simulate a random payment failure 10% of the time
      if (Math.random() < 0.1) {
        reject({ success: false, message: "Payment failed. Try again." });
      } else {
        resolve({
          success: true,
          message: "Payment successful",
          transactionId: `txn_${Math.random().toString(36).substr(2, 9)}`,
          orderId,
          amount,
          method,
          details, // echo back for verification (optional)
          timestamp: new Date().toISOString(),
        });
      }
    }, 1000);
  });
};